import type { AwaitOptions, Key } from './types'

/**
 * @experimental This is experimental feature.
 */
export const awaitOptions = <TData, TKey extends Key>(options: AwaitOptions<TData, TKey>) => {
  return options
}
